export const merchantMessagesState = {
  merchantMessages: null,
  showThread:false,
  showConv:true,
  fullName:null
};
